// src/redux/store.js
import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk'; // Updated import
import rootReducer from './reducers';

const initialState = {};
const middleware = [thunk];

const store = createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(...middleware),
    // Enable Redux DevTools if available
    window.__REDUX_DEVTOOLS_EXTENSION__ 
      ? window.__REDUX_DEVTOOLS_EXTENSION__() 
      : f => f
  )
);

export default store;